"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeaserWithBackground = exports.TEASER_EVOLUTION_TYPE = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _BannerBackground = require("./BannerBackground");
require("./TeaserWithBackground.scss");
let TEASER_EVOLUTION_TYPE = exports.TEASER_EVOLUTION_TYPE = /*#__PURE__*/function (TEASER_EVOLUTION_TYPE) {
  TEASER_EVOLUTION_TYPE["banner"] = "banner";
  TEASER_EVOLUTION_TYPE["size100"] = "size100";
  TEASER_EVOLUTION_TYPE["size66"] = "size66";
  TEASER_EVOLUTION_TYPE["size50"] = "size50";
  TEASER_EVOLUTION_TYPE["size33"] = "size33";
  return TEASER_EVOLUTION_TYPE;
}({});
const TeaserWithBackground = _ref => {
  let {
    imageUrl,
    logoUrl,
    title,
    content,
    buttonLabel,
    url,
    type,
    handleClick,
    contentTitleClass,
    contentTextClass,
    imageClassName
  } = _ref;
  const hasContent = title || content || buttonLabel && url;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_BannerBackground.BannerBackground, {
    className: "TeaserWithBackground-RoundedBackground",
    hasBackground: hasContent,
    imageUrl: imageUrl,
    imageClassName: imageClassName
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Teaser-ContentWrapper"
  }, logoUrl && /*#__PURE__*/_react.default.createElement("img", {
    alt: title,
    className: "cds-Teaser-Logo",
    src: logoUrl
  }), hasContent && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Teaser-ContentInner"
  }, title && /*#__PURE__*/_react.default.createElement("h3", {
    className: contentTitleClass
  }, title), content && /*#__PURE__*/_react.default.createElement("div", {
    className: contentTextClass
  }, content), buttonLabel && url && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Teaser-CTA"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    size: type === TEASER_EVOLUTION_TYPE.banner ? _Button.BUTTON_SIZE.default : _Button.BUTTON_SIZE.small,
    onClick: handleClick
  }, buttonLabel)))));
};
exports.TeaserWithBackground = TeaserWithBackground;
//# sourceMappingURL=TeaserWithBackground.js.map